import { Routes } from "@angular/router";
import { DashboardLayoutSettingComponent } from "./components/dashboard-layout-setting/dashboard-layout-setting.component";
import { Qr1CompleteComponent } from "./components/qr1-complete/qr1-complete.component";
import { Qr2CompleteComponent } from "./components/qr2-complete/qr2-complete.component";
import { Qr3CompleteComponent } from "./components/qr3-complete/qr3-complete.component";
import { Qr4CompleteComponent } from "./components/qr4-complete/qr4-complete.component";
import { DashboardComponent } from "./dashboard.component";
import { NewDashboardComponent } from "./components/new-dashboard/new-dashboard.component";

export const dashboardRoutes: Routes = [
  {
    path: "",
    component: DashboardComponent,
  },
  {
    path: "quadreport1",
    component: Qr1CompleteComponent,
  },
  {
    path: "quadreport2",
    component: Qr2CompleteComponent,
  },
  {
    path: "quadreport3",
    component: Qr3CompleteComponent,
  },
  {
    path: "quadreport4",
    component: Qr4CompleteComponent,
  },
  {
    path: "dashboard-setting",
    component: DashboardLayoutSettingComponent,
  },
  {
    path: "new-dashboard",
    component: NewDashboardComponent,
  },
];
